const actions = {
  createProject: require('./createProject').default,
  loadProject: require('./loadProject').default,
  saveProject: require('./saveProject').default
}

export default actions
